// opervex-frontend/src/pages/Reports/GoodsMovementFull.js

import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import DynamicReport from "../../components/DynamicReport";
import useOpervex from "../../hooks/useOpervex";

const GoodsMovementFull = () => {
  const [schema, setSchema] = useState(null);
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const loadSchema = async () => {
      const result = await OpervexAPI.Report.GoodsMovementFull.schema();
      setSchema(result);
    };

    loadSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!schema)
    return (
      <Container fluid className="text-center mt-5">
        <span>Carregando relatório...</span>
      </Container>
    );

  return (
    <>
      <h1 className="fw-light text-center">Relatório de Movimentação - Completo</h1>

      <DynamicReport
        reportName={"reportGoodsMovementFull"}
        urlData={"/Report/GoodsMovementFull"}
        schema={schema}
        links={[{ key: "id", link: "/MaterialManagement/GoodsMovement/:id", newPage: true }]}
      />
    </>
  );
};

export default GoodsMovementFull;
